import * as React from 'react';
import { Button } from "primereact/button";
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import { ActiveIngredientAdminModel } from "../../../models/activeIngredient";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import getInteractionSeverity from './interactionsSeverityFunctions';
import { DrugToFoodAlcoholInteractionModel } from "../../../models/activeIngredient";
import { Lang } from '../../../common/enums';
import { DrugInteractionContentModel } from '../../../models/activeIngredient/drugInteractionContentModel';
import * as HelperFunctions from '../../../common/functions/helperFunctions';

interface IProps {
  activeIngredient: ActiveIngredientAdminModel
  removeFoodAlcoholInteractionClick: any,
  setIsVisibleFoodAlcoholAddEditInteractionDialog: any,
  setIsFoodAlcoholDropdownDisabled: any,
  onAddEditFoodAlcoholInteractionClick: any
}

interface IState {
  validationMessage: string;
}

class ActiveIngredientTabFoodAlcoholInteraction extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
      validationMessage: ''
    };
  }

  handleFoodAlcoholAddEditClick = (foodId, selectedIngredientId) => {
    if (!foodId) { // Add		
      let newFoodInteraction = new DrugToFoodAlcoholInteractionModel();
      newFoodInteraction.selectedIngredientId = selectedIngredientId;

      let contentList = new Array<DrugInteractionContentModel>(0);
      const langKeys = HelperFunctions.getEnumKeys(Lang);

      langKeys.map(k => {
        let content = new DrugInteractionContentModel();
        content.langId = parseInt(Lang[k]);
        content.professionalDecscription = '';
        content.consumerDecscription = '';
        contentList.push(content);
      });

      newFoodInteraction.drugToFoodAlcoholInteractionContent = contentList;

      this.handleFoodAlcoholInteractionAddButton(newFoodInteraction, false);
    } else {
      let currentFoodAlcoholInteraction = this.props.activeIngredient.drugToFoodAlcoholInteractions.
        find(f => f.foodAlcoholId === foodId && f.selectedIngredientId === selectedIngredientId);
      if (currentFoodAlcoholInteraction) {
        this.handleFoodAlcoholInteractionAddButton(currentFoodAlcoholInteraction, true);
      }
      else {
        this.setState({
          validationMessage: 'Erorororororo'
        });
      }
    }
  }

  handleFoodAlcoholInteractionAddButton(foodAlcoholInteraction: DrugToFoodAlcoholInteractionModel, isDisabled: boolean) {
    this.props.onAddEditFoodAlcoholInteractionClick(foodAlcoholInteraction)
    this.props.setIsVisibleFoodAlcoholAddEditInteractionDialog(true);
    this.props.setIsFoodAlcoholDropdownDisabled(isDisabled);
  }

  public render() {

    const { activeIngredient } = this.props;
    const currentActiveIngredientId = this.props.activeIngredient.activeIngredientId ? this.props.activeIngredient.activeIngredientId : -1;

    return (
      <div style={{ minHeight: '550px', maxHeight: '650px' }}>
        {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
        <div className="p-grid p-md-12">
          <div className="p-col-12 p-md-12">
            <div className="mb-2">
              <button
                onClick={() => this.handleFoodAlcoholAddEditClick(null, currentActiveIngredientId)}
                className="btn btn-success"
                style={{ marginRight: "5px" }}>
                Add New
									</button>
            </div>
            <DataTable
              value={activeIngredient.drugToFoodAlcoholInteractions}
              dataKey='foodAlcoholId'
            >
              <Column
                header="Name"
                field="foodAlcoholName" />
              <Column
                header="Interaction severity"
                field="interactionTypeId"
                body={(rowData, column) =>
                  <div>
                    {getInteractionSeverity('iconLabel', rowData.interactionTypeId)}
                  </div>}
              />
              <Column
                header="Actions"
                style={{ textAlign: "center", width: "8em" }}
                body={(rowData, column) =>
                  <div>
                    <Button
                      type="button"
                      icon="pi pi-pencil"
                      className="p-button-warning"
                      tooltip="Edit"
                      tooltipOptions={{ position: 'top' }}
                      style={{ marginRight: ".5em" }}
                      onClick={() => this.handleFoodAlcoholAddEditClick(rowData.foodAlcoholId, rowData.selectedIngredientId)}
                    />
                    <Button
                      type="button"
                      icon="pi pi-trash"
                      className="p-button-danger"
                      tooltip="Remove"
                      tooltipOptions={{ position: 'top' }}
                      onClick={() => this.props.removeFoodAlcoholInteractionClick(rowData.selectedIngredientId, rowData.interactionTypeId, rowData.foodAlcoholId)}
                    />
                  </div>
                }
              />
            </DataTable>
          </div>
        </div>
      </div>
    )
  }
}

export default ActiveIngredientTabFoodAlcoholInteraction;